<div id="issue-return" class="watermark">
  <div class="container-fluid px-lg-5 py-4">
    <div class="row">
      <div class="col-12">
        <h2 class="title mb-4">Issue and Return</h2>
      </div>

      <div class="col-12">
        <p class="inner-lead fw-bold">Issuing Library Books</p>

        <ol class="inner-lead">
          <li>
            <strong>Book Selection:</strong> Choose the books you want to borrow from the library’s collection.
          </li>
          <li>
            <strong>Check-Out:</strong> Take the selected books to the circulation desk for check-out.
          </li>
          <li>
            <strong>Fines:</strong> Be aware of the fine policy for late returns.
          </li>
        </ol>

        <p class="inner-lead fw-bold">Returning Library Books</p>

        <ol class="inner-lead">
          <li>
            <strong>Return Date:</strong> Ensure books are returned on or before the due date.
          </li>
          <li>
            <strong>Book Condition:</strong> Return books in good condition, with no damage or markings.
          </li>
          <li>
            <strong>Renewal:</strong> If needed, renew books before the due date to avoid fines.
          </li>
          <li>
            <strong>Overdue Fines:</strong> Pay fines for late returns, if applicable.
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>
